import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { CachingService } from '../../../../../../projects/jv-common/src/public_api';
import { BsModalRef, BsDatepickerConfig } from 'ngx-bootstrap';
import { DatePipe } from '@angular/common';
import { ApiService } from '../../../../../../projects/accounting/src/public_api';

@Component({
  selector: 'app-mass-transfer-resolver',
  templateUrl: './mass-transfer-resolver.component.html',
  styleUrls: ['./mass-transfer-resolver.component.scss']
})
export class MassTransferResolverComponent implements OnInit, OnDestroy {

  data: any = null;

  @Output()
  public closed: EventEmitter<boolean> = new EventEmitter<boolean>();

  private key: string;
  private depositCache = null;
  private transferCache = null;

  loading: boolean = true;
  changed: boolean = false;

  title: string;
  error: string;

  deposit: boolean = false;

  bsDate: Date = new Date();

  bsConfig: BsDatepickerConfig = {
    containerClass: 'theme-angle custom-date',
    dateInputFormat: 'DD/MM/YYYY',
    displayMonths: 1,
    showWeekNumbers: false,
    rangeSeparator: " - ",
    rangeInputFormat: "DD/MM/YYYY",
    monthTitle: "TMM",
    yearTitle: "YYYY",
    dayLabel: "DD",
    monthLabel: "",
    yearLabel: "",
    weekNumbers: "",
    maxDate: new Date()
  }

  constructor(
    private cache: CachingService,
    public modal: BsModalRef,
    private date: DatePipe,
    private api: ApiService
  ) { }

  ngOnInit() {

    this.cache.get("last-mass-transfer", { code: null, period: null, date: null, orders: [] }).subscribe(data => {
      this.transferCache = data;
      this.loading = this.depositCache == null || this.transferCache == null;
    });

    this.cache.get("last-mass-deposit", { code: null, period: null, date: null, orders: [] }).subscribe(data => {
      this.depositCache = data;
      this.loading = this.depositCache == null || this.transferCache == null;
    });
  }

  ngOnDestroy() {
    this.closed.emit(this.changed);
  }

  test($event) {

    let value: string = $event.target.value.toUpperCase();

    let data = null;
    let key: string = null;
    let title: string = null;

    if (value == this.depositCache.code) {

      key = "last-mass-deposit";
      title = "GHI NHẬN CHI CHO YÊU CẦU TẠM ỨNG THEO LÔ";
      data = this.depositCache;
    }

    if (value == this.transferCache.code) {

      key = "last-mass-transfer";
      title = "GHI NHẬN CHI CHO YÊU CẦU THANH TOÁN THEO LÔ";
      data = this.transferCache;
    }

    if (data != null && data.orders.length > 0) {

      this.key = key;
      this.title = title;
      this.data = data;
    }

    this.error = data == null ? "Mã xác nhận không đúng" : this.data == null ? "Mã đã được xác nhận" : "";
    if (this.data != null) this.bsConfig.minDate = new Date(this.data.date);
  }

  confirm(order) {

    this.loading = true;

    let buffer = this.data.orders;
    this.data.orders = this.data.orders.filter(i => i != order);

    this.cache.set(this.key, this.data).subscribe(succeed => {

      if (succeed) {

        let request = {
          ID: order.info.id,
          Amount: order.amount,
          Bank: order.source.name,
          Period: this.data == this.depositCache ? this.date.transform(new Date(), "MM-yyyy") : this.data.period,
          Date: this.date.transform(this.bsDate, "dd-MM-yyyy")
        }

        this.api.payToVendor(request).subscribe(response => {

          if (!response.succeed || !response.data) {
            this.data.orders = buffer;

            this.cache.set(this.key, this.data).subscribe(succeed => {
              this.loading = false;
            });
          }
          else {
            this.loading = false;
            this.changed = true;
          }
        });
      }
      else {
        this.loading = false;
        this.data.orders = buffer;
      }
    });
  }
}
